"use client";

import React from "react";
import Link from "next/link";
import useWidth from "@/hooks/useWidth";
import Image from "next/image";

const Logo = () => {
  const { width, breakpoints } = useWidth();

  return (
    <div>
      <Link href="/">
        <React.Fragment>
          {width >= breakpoints.xl ? (
            <Image
              src={
                "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
                  
              }
              alt="mxs-logo"
              className="h-8 w-8"
              width={370}
              height={411}
              role="img"
            />
          ) : (
            <Image
              src={
                "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
              }
              alt="mxs-logo"
              className="h-8 w-8"
              width={370}
              height={411}
              role="img"
            />
          )}
        </React.Fragment>
      </Link>
    </div>
  );
};

export default Logo;
